import { Spin } from 'antd';
import React from 'react';

function Spinner({ className = '', spinClassName, ...rest }) {
  return (
    <div className={`d-flex align-center justify-center ${className}`}>
      <Spin className={spinClassName} {...rest} />
    </div>
  );
}

export default Spinner;
